var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"online-pay"},[_c('el-payform',{attrs:{"btnName":"确认购买"},on:{"get-formdata":_vm.formDataCallback}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }